import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons'; 
import {LabelText} from '../../Language/LabelText';
import './UserInformation.css'

export default function UserInformation(props) { 

    return (
      <div className = "UserInformationContainer">
          <FontAwesomeIcon icon = {faUser} />
          <div className = "UserinfomationCont">
                <span className = 'WelcomeLabel'><LabelText tid="Welcome"/></span>
                <span className = "UserIdLabel">{props.userId ? props.userId : "" }</span>
          </div>
       </div>
   );
}

